(function(){
  function updateYear(){
    var el = document.querySelector('.section-footer .copyright .copy');
    if(!el) return;
    var year = new Date().getFullYear();
    var text = el.textContent || '';
    var replaced = text.replace(/©\s*\d{4}/, '© ' + year);
    if(replaced !== text) el.textContent = replaced;
  }
  function init(){
    updateYear();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
